import React from 'react';

export const MetaforceContext = React.createContext();
export const WebEditorContext = React.createContext();
export const SelectableTextContext = React.createContext();
export const TextLibraryContext = React.createContext();
export const DistributionContext = React.createContext();
export const DiscardContext = React.createContext();
export const DxmlBreakTableBodyContext = React.createContext();
export const SplitViewContext = React.createContext();
export const PageElementContext = React.createContext();
